export const UPLOAD_IMAGE_SIZES = {
  UPLOAD: 'upload',
  THUMB: 'thumb',
  SMALL: 'small',
  TINY: 'tiny'
};


export const imageSizeOptions = [{
  label: 'Upload',
  value: UPLOAD_IMAGE_SIZES.UPLOAD
}, {
  label: 'Thumb',
  value: UPLOAD_IMAGE_SIZES.THUMB
}, {
  label: 'Small',
  value: UPLOAD_IMAGE_SIZES.SMALL
}, {
  label: 'Tiny',
  value: UPLOAD_IMAGE_SIZES.TINY
}];
